import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { getRegisteredBuses, clearRegisteredBuses } from '../../../../actions';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { registeredBusesGenerator } from '../../../../utils/app/json-generator-from-reducer';
import { registeredBusBasicInformationPropTypes } from '../../../units/bus/registered-bus/proptypes/RegisteredBusPropTypes';

class RegisteredBusSelect extends Component {
  componentWillUnmount() {
    const { dispatchClearRegisteredBuses } = this.props;

    dispatchClearRegisteredBuses();
  }

  handleRegisteredBusChange = (inputValue) => {
    const { dispatchGetRegisteredBuses, onlyActive } = this.props;

    const query = [];

    if (onlyActive) {
      query.push('active:true');
    }

    if (inputValue.trim().length) {
      query.push(`companyBusId:${inputValue}`);
      dispatchGetRegisteredBuses({ query });
    }
  };

  render() {
    const {
      registeredBuses,
      isLoading,
      isMulti,
      input,
      meta,
      isDisabled,
      isGridVariant,
      onBlur,
      onValueChange,
      autoFocus,
      isClearable,
      ...rest
    } = this.props;

    return (
      <Select
        options={registeredBuses}
        isLoading={isLoading}
        isMulti={isMulti}
        input={input}
        meta={meta}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isGridVariant={isGridVariant}
        onValueChange={onValueChange}
        onInputChange={this.handleRegisteredBusChange}
        onBlur={onBlur}
        autoFocus={autoFocus}
        {...rest}
      />
    );
  }
}

RegisteredBusSelect.propTypes = {
  dispatchGetRegisteredBuses: PropTypes.func.isRequired,
  dispatchClearRegisteredBuses: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  registeredBuses: PropTypes.arrayOf(
    PropTypes.shape(registeredBusBasicInformationPropTypes),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isGridVariant: PropTypes.bool,
  onValueChange: PropTypes.func,
  isClearable: PropTypes.bool,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  onlyActive: PropTypes.bool,
};

RegisteredBusSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isDisabled: false,
  isMulti: false,
  registeredBuses: [],
  isGridVariant: false,
  isClearable: false,
  onValueChange: undefined,
  onBlur: undefined,
  autoFocus: false,
  onlyActive: false,
};

const mapStateToProps = ({ BusUnit }) => ({
  registeredBuses: registeredBusesGenerator(
    BusUnit.RegisteredBus.getIn(['all', 'content', 'content']),
  ),
  isLoading: BusUnit.RegisteredBus.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetRegisteredBuses: getRegisteredBuses,
  dispatchClearRegisteredBuses: clearRegisteredBuses,
};

export default connect(
  mapStateToProps,
  mapDispatchToprops,
)(RegisteredBusSelect);
